export enum SelectionGroupType {
    ExtraGroup = "EXTRA_GROUP",
    Option = "OPTION",
}
